import { ApiClientError } from "./api-client";

// Centralize zod-issue → toast-message extraction. The worker emits
// `{ error: { code: "validation", details: { issues: [...] } } }` for
// schema-validation failures; ApiClientError stuffs `details` straight onto
// the instance. Prefer the first issue's message when present, fall back to
// the top-level message, then the caller-supplied default.
//
// Phase 7 sub-bucket 11 onwards. Adopted incrementally by hooks whose
// mutations can surface zod errors (admin forms editor is the first
// consumer; older hooks can adopt opportunistically).

type ZodIssueLike = { message?: string; path?: ReadonlyArray<unknown> };

export function formatApiError(err: unknown, fallback: string): string {
  if (!(err instanceof ApiClientError)) {
    return err instanceof Error ? err.message : fallback;
  }
  const details = err.details as { issues?: ReadonlyArray<ZodIssueLike> } | null | undefined;
  const issue = details?.issues?.[0];
  if (issue?.message) return issue.message;
  return err.message || fallback;
}
